import React from 'react'
import styles from './Login.module.css'

function LogoImg({ src, alt }) {
  return (
    <img className={styles.form_image} src={require('../../static/images/login_logo_colorida.png')} alt="Loeffa" />
  )
}

export default LogoImg